



import React, { useContext, useState, useEffect } from "react"
import { Config } from "../config/Config"


const AuthContext = React.createContext()
let config = process.env.REACT_APP_SERVER === 'dev' ? Config.DEV : process.env.REACT_APP_SERVER === 'prod' ? Config.PROD : Config.LOCAL;

export function appAuth() {
    return useContext(AuthContext)
}

export function AppProvider({ children }) {


    const [loading, setLoading] = useState(false)
    const [allApps, setAllApps] = useState([])
    const [currentApp, setCurrentApp] = useState()


    const [loadingSuccessData, setLoadingSuccessData] = useState()
    const [alertMessage, setAlertMessage] = useState()
    const [requestError, setRequestError] = useState()
    const [requestSuccess, setRequestSuccess] = useState()
    const [loggedInUser, setLoggedInUser] = useState()
    const [qrWebUrl, setQRWebUrl] = useState(config.QR_WEB_URL) 

    async function checkURL(url) {
        let requestOptions = {
            method: 'GET',
        };

        console.log("checkURL url ", url)

        const response = await fetch(url, requestOptions);

        console.log("apiRequest response ", response)
        let result = await response.json();

        return result
    }

    async function apiRequest(method, path, data, showLoading = true, file) {

        try { 

            let user = null;
            const session = sessionStorage.getItem('appkey.io.user');
            if (session) user = JSON.parse(session);
            else {
                const catche = localStorage.getItem("appkey.io.user");
                user = JSON.parse(catche);
            } 

            console.log("apiRequest path ", path)

            if (!user || user["access-token"] === undefined) {
                //console.log("apiRequest Invalid user ", user)

                setAlertMessage({message: "Invalid User, Please logout and login again."})

                return
            }


            setRequestError(null)
            if (showLoading) setLoading(true)

            let requestOptions = {
                method: method || 'POST',
                headers: {
                    "access-token": user["access-token"]
                }
            };


            if (file) {
                const formData = new FormData();
                formData.append('file', file);
                formData.append('appName', data.appName);
                requestOptions.body = formData;
               

            }
            else {
                requestOptions.headers['Content-Type'] = 'application/json';

                if (method !== "GET" && method !== "DELETE") {
                    requestOptions.body = JSON.stringify(data)
                }
            }

 

            let endpoint = `${config.REST_API}/api/${path}`
            const response = await fetch(endpoint, requestOptions);
            let result = await response.json();

            console.log("apiRequest result ", result)


            if (response.status !== 200) {

                setRequestError(result);

                if(result.code === 501 || result.code === 405){
                    setAlertMessage({ message: "Invalid access token, Please logout and login again." })
                    
                    setTimeout(() => {
                        window.location.href = "/signout"
                    }, 1000);
                } 

                return { error: result }
            }
            else {
                return result;
            }


        } catch (error) {

            setRequestError({ message: "Something went wrong!" })
            return { error: error }
        }
        finally {
            setLoading(false)
        }

    }

    async function createApp(data) {

        let checked = allApps.filter(app => app.name.toLowerCase() == data.name.toLowerCase())[0];
        if (checked) {
            return { error: { message: `App name '${data.name}' already exists.` } }
        }

        let temp = { name: data.name, status: "pending", appId: data.name }
        setAllApps(prevItems => {
            return [temp, ...prevItems];
        });

        let result = await apiRequest("POST", "app/create", data, false)

        setAllApps(
            allApps.filter(app =>
                app.name !== data.name
            )
        );

        if (!result.error) {
            setAllApps(prevItems => {
                return [data, ...prevItems];
            });
        }

        setRequestError(null);

        return result;
    }

    async function updateApp(appId, option, value) {
        console.log("updateApp updated option", option)

        let requestData = { appId: appId }
        requestData[option] = value
        requestData.option = option


        let data = await apiRequest("POST", "app/update", requestData, false)


        if (data.error) return data
        else {
            console.log("updateApp Success updated")

            setRequestSuccess({ message: "Successful updated." })

            let list = allApps.map(app => {
                if (app.appId === appId) {
                    return { ...app, [option]: value };
                } else {
                    // No changes
                    return app;
                }
            })


            setAllApps(list);

            setCurrentApp({
                ...currentApp,
                [option]: value
            })

            localStorage.setItem('isUpdatingUser', "false");  

            return list;
        }
    }

    async function resetApp(appId) {
        let data = await apiRequest("POST", "app/resetApp", { appId: appId })
        if (data.error) return data
        else return true
    }



    async function appLogs(filter, exportLog) {
        let query = ""
        if (filter.type && filter.type.length) {
            query += `&type=${filter.type.toString().toLowerCase()}`
        }

        if (filter.search && filter.search.length) {
            query += `&search=${filter.search.toString().toLowerCase()}`
        }

        if (filter.filterAction && filter.filterAction.length) {
            query += `&filterAction=${filter.filterAction.toString()}`
        }

        if (filter.status && filter.status.length) {
            query += `&status=${filter.status.toString().toLowerCase()}`
        }

        if (filter.fromDate) {
            query += `&fromDate=${filter.fromDate}`
        }

        if (filter.toDate) {
            query += `&toDate=${filter.toDate}`
        }

        if (filter.limit) {
            query += `&limit=${filter.limit}`
        }

        if (filter.offset) {
            query += `&offset=${filter.offset - 1}`
        }

        query += `&export=${exportLog}`

        let data = await apiRequest("GET", `app/logs?appId=${filter.appId}${query}`)
        if (data.error) setAlertMessage(data.error)
        else {
            return data
        }

    }


    async function deleteApp(appId) {

        let data = await apiRequest("DELETE", `app/deleteApp/${appId}`)
        if (data.error) return data
        else {
            setCurrentApp()
            return true
        }
    }


    async function getAllApp() {
 
        let data = await apiRequest("GET", "app/allApps", {})
        if (data && data.error) {
            setAllApps([])
            return null
        }
        else if (data) {
            setAllApps(data);
            return data
        }


    }

    const testAppEmailExt = async (appId, email) => {

        let data = await apiRequest("POST", "app/testAppEmailExt", { appId: appId, toEmail: email })

        if (data.error) setAlertMessage(data.error)
        else return true
    }


    const testAppSMSExt = async (appId, number) => {

        let data = await apiRequest("POST", "app/testAppSMSExt", { appId: appId, toNumber: number })

        if (data.error) setAlertMessage(data.error)
        else return true
    }


    const getApp = async (appId) => {


        if (allApps.length > 0) {
            let app = allApps.filter(item => item.appId == appId)[0]

            console.log("getApp data = ", app)
            setCurrentApp(app)
            return app
        }
        else {
            console.log("getAllApp ")

            let apps = await getAllApp();
            if (!apps) {
                setAlertMessage("Invalid App ID")
                return null
            }
            else {
                let app = apps.filter(item => item.appId == appId)[0]
                setCurrentApp(app)
                return app
            }
        }


    }



    const createAppInvite = async (appId, values) => {

        let result = await apiRequest("POST", "app/createAppSignupInvite", { appId: appId, emails: values })

        if (result.error) setAlertMessage(result.error)
        else {
            let message = ""
            if (result.invites && result.invites.length) {

                message = `Your invitation has been sent to: ${result.invites}.`;

                if (result.exists && result.exists.length) {
                    if (result.exists.length > 1) message = message + `<br/>These emails already registered: ${result.exists}.`
                    else message = message + `<br/>This email already registered: ${result.exists}.`
                }

            }
            else if (result.exists && result.exists.length) {
                if (result.exists.length > 1) message = message + `These emails already registered: ${result.exists}.`
                else message = message + `This email already registered: ${result.exists}.`
            }

            setLoadingSuccessData({ message: message })
        }

        return result
    }

    const getAppEmailTemplate = async (appId) => {
        let result = await apiRequest("GET", `app/emailTemplates?appId=${appId}`)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }

    const updateEmailTemplate = async (template) => {
        let result = await apiRequest("POST", `app/updateEmailTemplate`, template, false)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }


    const updateAppLocale = async (data) => {
        let result = await apiRequest("POST", `app/updateAppLocale`, data, false)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }


    const getAppUser = async (filter) => {

        let query = ""
        if (filter.search) {
            query += `&search=${filter.search}`
        }

        if (filter.groupId) {
            query += `&groupId=${filter.groupId}`
        }

        if (filter.fromDate) {
            query += `&fromDate=${filter.fromDate}`
        }

        if (filter.toDate) {
            query += `&toDate=${filter.toDate}`
        }

        if (filter.limit) {
            query += `&limit=${filter.limit}`
        }

        if (filter.offset) {
            query += `&offset=${filter.offset - 1}`
        }

        let result = await apiRequest("GET", `app/appuser?appId=${currentApp.appId}${query}`)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }


    const updateAppUserStatus = async (user, status) => {
        let result = await apiRequest("POST", `app/updateAppUserStatus`, { handle: user.handle, appId: user.appId, status: status })
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }


    const deleteAppUser = async (data, groupId) => {
        let result = await apiRequest("POST", `app/deleteAppUser`, { handle: data.handle, appId: data.appId, groupId:groupId })
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }

    
    
    const updateActionQR  = async (data) => {
        let result = await apiRequest("POST", `app/updateActionQR`, data)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }

    
    const copyActionQR  = async (data) => {
        let result = await apiRequest("POST", `app/copyActionQR`, data)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }


    const createActionQR  = async (data) => {
        let result = await apiRequest("POST", `app/createActionQR`, data)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }


    const deleteActionQR = async (data) => {
        let result = await apiRequest("POST", `app/deleteActionQR`, data)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }

    const getActionQR = async (actionId) => {

        let query = `&actionId=${actionId}`
       
        let result = await apiRequest("GET", `app/actionQRs?appId=${currentApp.appId}${query}`)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }


    const updateAppActionCeremony  = async (action, ceremony) => {

        let data = {
            appId:action.appId,
            actionId: action.actionId,
            ceremony:ceremony
        }
        let result = await apiRequest("POST", `app/updateAppActionCeremony`, data)

        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }
    
    const updateAppAction  = async (data) => {
        let result = await apiRequest("POST", `app/updateAppAction`, data)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }

    const createAppAction  = async (data) => {
        let result = await apiRequest("POST", `app/createAppAction`, data)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }

    const deleteAppAction = async (data) => {
        let result = await apiRequest("POST", `app/deleteAppAction`, data)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }
    
    const getAppAction = async (filter) => {

        let query = ""
        if (filter.search) {
            query += `&search=${filter.search}`
        }

        if (filter.fromDate) {
            query += `&fromDate=${filter.fromDate}`
        }

        if (filter.toDate) {
            query += `&toDate=${filter.toDate}`
        }

        if (filter.limit) {
            query += `&limit=${filter.limit}`
        }

        if (filter.offset) {
            query += `&offset=${filter.offset - 1}`
        }

        let result = await apiRequest("GET", `app/actions?appId=${currentApp.appId}${query}`)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }


    const getActionEmailTemplate = async(actionId) => {
        let result = await apiRequest("GET", `app/actionEmailTemplates?actionId=${actionId}`)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }

    const updateActionEmailTemplate = async(template) => {
       
        let result = await apiRequest("POST", `app/updateActionEmailTemplate`, template, false)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    
    }

    const createAppGroup  = async (data) => {
        let result = await apiRequest("POST", `app/createAppGroup`, data)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }

    const deleteAppGroup  = async (group) => {
        let result = await apiRequest("POST", `app/deleteAppGroup`, group)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }
    


    const updateAppGroup  = async (data) => {
        let result = await apiRequest("POST", `app/updateAppGroup`, data)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }

    const getAppGroup = async (filter) => {

        let query = ""
        if (filter.search) {
            query += `&search=${filter.search}`
        }

        if (filter.fromDate) {
            query += `&fromDate=${filter.fromDate}`
        }

        if (filter.toDate) {
            query += `&toDate=${filter.toDate}`
        }

        if (filter.limit) {
            query += `&limit=${filter.limit}`
        }

        if (filter.offset) {
            query += `&offset=${filter.offset - 1}`
        }

        let result = await apiRequest("GET", `app/groups?appId=${currentApp.appId}${query}`)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }

    
    const updateAppUserGroup  = async (data) => {
       
        let result = await apiRequest("POST", `app/updateUserGroup`, data)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }

    const getAppSignup = async (filter) => {

        let query = ""
        if (filter.search) {
            query += `&search=${filter.search}`
        }

        if (filter.fromDate) {
            query += `&fromDate=${filter.fromDate}`
        }

        if (filter.toDate) {
            query += `&toDate=${filter.toDate}`
        }

        if (filter.limit) {
            query += `&limit=${filter.limit}`
        }

        if (filter.offset) {
            query += `&offset=${filter.offset - 1}`
        }


        let result = await apiRequest("GET", `app/signup?appId=${currentApp.appId}${query}`)
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }

    const deleteAppSignup = async (data) => {
        let result = await apiRequest("POST", `app/deleteAppSignup`, { handle: data.handle, appId: data.appId })
        if (result.error) {
            setAlertMessage(result.error)
            return null
        }
        else {
            return result
        }
    }

    const verifyHandle = async (data) => {
        let result = await apiRequest("POST", `app/verifyHandle`, data)
        if (result.error) {
            setAlertMessage(result.error)
        }
        return result
    }

    const createAppSignup = async (data) => {
        let result = await apiRequest("POST", `app/createAppSignup`, data)
        if (result.error) {
            setAlertMessage(result.error)
        }
        return result
    }


    const createUserSignup = async (data) => {
        let result = await apiRequest("POST", `appuser/signup`, data)
        if (result.error) {
            setAlertMessage(result.error)
        }

        return result
    }

    const verifiyUserSignup = async (data) => {
        let result = await apiRequest("POST", `appuser/signupConfirm`, data)
        if (result.error) {
            setAlertMessage(result.error)
        }

        return result
    }

    const signupComplete = async (data) => {
        let result = await apiRequest("POST", `appuser/signupComplete`, data)
        if (result.error) {
            setAlertMessage(result.error)
        }
        //else setLoadingSuccessData({message:"You have signed up successfully"})

        return result
    }

    const loginAnonymous = async (data) => {



        let result = await apiRequest("POST", `appuser/loginAnonymous`, data)
        if (result.error) {
            setAlertMessage(result.error)
        }

        return result
    }

    const loginAnonymousComplete = async (data) => {

        let result = await apiRequest("POST", `appuser/loginAnonymousComplete`, data)
        if (result.error) {
            setAlertMessage(result.error)
        }

        return result
    }

    const login = async (data) => {
        let result = await apiRequest("POST", `appuser/login`, data)
        if (result.error) {
            setAlertMessage(result.error)
        }
        //else setLoadingSuccessData({message:"You have signed up successfully"})

        return result
    }

    const loginComplete = async (data, showSuccess = false) => {
        let result = await apiRequest("POST", `appuser/loginComplete`, data)
        if (result.error) {
            setAlertMessage(result.error)
        }
        else if (showSuccess) setLoadingSuccessData({ message: "You have logged in successfully" })

        return result
    }

    const verifyUser = async (data) => {
        let result = await apiRequest("POST", `appuser/verify`, data)
        if (result.error) {
            setAlertMessage(result.error)
        }
        //else setLoadingSuccessData({message:"You have signed up successfully"})

        return result
    }

    const verifyUserComplete = async (data, showSuccess = false) => {
        let result = await apiRequest("POST", `appuser/verifyComplete`, data)
        if (result.error) {
            setAlertMessage(result.error)
        }
        else if (showSuccess) setLoadingSuccessData({ message: "Your account has been verified successfully" })

        return result
    }


    async function addPasskey(handle, appId) {
        try {

            let response = await apiRequest("POST", "appuser/addPasskey", { handle: handle, appId: appId }, false)

            return response;

        } catch (error) {
            console.error(error)
            return { error: error }
        }
    }




    async function addPasskeyComplete(authData) {
        try {

            let response = await apiRequest("POST", "appuser/addPasskeyComplete", authData, false)

            console.log("addPasskeyComplete response = ", response)
            if (response.error) {
                return response
            }
            else {

                return response;
            }

        } catch (error) {
            console.error(error)
            return { error: error }
        }
    }




    async function resetAppUserPasskey(authData) {
        try {

            let response = await apiRequest("POST", "appuser/resetAppUserPasskey", authData, false)

            console.log("resetAppUserPasskey response = ", response)
            if (response.error) {
                return response
            }
            else {

                return response;
            }

        } catch (error) {
            console.error(error)
            return { error: error }
        }
    }

    async function importAppDatabase(data, file) {

        return await apiRequest("POST", "app/importApp", data, true, file)
    }

    async function exportAppDatabase(data) {
        setLoading(true)

        const catche = localStorage.getItem("appkey.io.user");
        let user = JSON.parse(catche);
        let requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "access-token": user["access-token"]
            },
            responseType: 'blob'
        };

        let endpoint = `${config.REST_API}/api/app/export/${data.appId}`
        const response = await fetch(endpoint, requestOptions);
        console.log("export response ", response)

        let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let today = new Date();
        let todayString = today.getDate() + "-" + months[today.getMonth()] + "-" + today.getFullYear();
        const blobFile = await response.blob();
        // const blobFile = new Blob([response]);
        const url = window.URL.createObjectURL(blobFile);
        let a = document.createElement('a');
        a.href = url;
        a.download = `${data.displayAppId}-database-export-${todayString}.zip`;
        a.click();
        window.URL.revokeObjectURL(url);


        a.remove(); // remove the element

        setLoading(false)

        return true;

    }


    async function exportAppUser(data) {
        setLoading(true)
        try {
            
        
            const catche = localStorage.getItem("appkey.io.user");
            let user = JSON.parse(catche);
            let requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    "access-token": user["access-token"]
                },
                responseType: 'blob'
            };

            let endpoint = `${config.REST_API}/api/app/exportAppUser/${data.appId}/${data.groupId}`
            const response = await fetch(endpoint, requestOptions);
            console.log("export response ", response)

            let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            let today = new Date();
            let todayString = today.getDate() + "-" + months[today.getMonth()] + "-" + today.getFullYear();
            const blobFile = await response.blob();
            // const blobFile = new Blob([response]);
            const url = window.URL.createObjectURL(blobFile);
            let a = document.createElement('a');
            a.href = url;
            a.download = `${data.displayAppId}-export-appuser-${todayString}.zip`;
            a.click();
            window.URL.revokeObjectURL(url);


            a.remove(); // remove the element

        } catch (error) {
            
        }
        setLoading(false)

        return true;

    }




    async function exportAppLog(filter, app) {
        setLoading(true)
        try {
            
            let query = ""
            if (filter.type && filter.type.length) {
                query += `&type=${filter.type.toString().toLowerCase()}`
            }

            if (filter.search && filter.search.length) {
                query += `&search=${filter.search.toString().toLowerCase()}`
            }

            if (filter.filterAction && filter.filterAction.length) {
                query += `&filterAction=${filter.filterAction.toString().toLowerCase()}`
            }

            if (filter.status && filter.status.length) {
                query += `&status=${filter.status.toString().toLowerCase()}`
            }

            if (filter.fromDate) {
                query += `&fromDate=${filter.fromDate}`
            }

            if (filter.toDate) {
                query += `&toDate=${filter.toDate}`
            }

            if (filter.limit) {
                query += `&limit=${filter.limit}`
            }

            if (filter.offset) {
                query += `&offset=${filter.offset - 1}`
            }

            query += `&export=1`

            const catche = localStorage.getItem("appkey.io.user");
            let user = JSON.parse(catche);
            let requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    "access-token": user["access-token"]
                },
                responseType: 'blob'
            };
 
            let endpoint = `${config.REST_API}/api/app/logs?appId=${filter.appId}${query}`
            const response = await fetch(endpoint, requestOptions);
            console.log("export response ", response)

            let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            let today = new Date();
            let todayString = today.getDate() + "-" + months[today.getMonth()] + "-" + today.getFullYear();
            const blobFile = await response.blob();
            // const blobFile = new Blob([response]);
            const url = window.URL.createObjectURL(blobFile);
            let a = document.createElement('a');
            a.href = url;
            a.download = `${app.displayAppId}-export-applog-${todayString}.zip`;
            a.click();
            window.URL.revokeObjectURL(url);


            a.remove(); // remove the element

        } catch (error) {
            console.log(error)
        }
        setLoading(false)

        return true;

    }



    function isLoggedIn() {
        try {
            const catche = localStorage.getItem("appkey.io.user");
            let loggedInUser = JSON.parse(catche);
            if (loggedInUser && loggedInUser['access-token']) {
                setLoggedInUser(loggedInUser);
                return true
            }
            else return false
        } catch (error) {
            return false
        }
    }

    async function updateAppIcon(appIcon) {
        try {

            let response = await apiRequest("POST", "app/updateIcon", appIcon, false)

            console.log("updateAppIcon response = ", response)
            if (response.error) {
                return response
            }
            else {

                return response;
            }

        } catch (error) {
            console.error(error)
            return { error: error }
        }
    }
 

    const value = {
        loading,
        allApps,
        currentApp,
        loggedInUser,
        requestError,
        requestSuccess,
        alertMessage,
        loadingSuccessData,
        qrWebUrl,
        isLoggedIn,
        setLoadingSuccessData,
        setRequestError,
        setRequestSuccess,
        setAlertMessage,
        setCurrentApp,
        getAllApp,
        getApp,
        createApp,
        updateApp,
        deleteApp,
        updateAppIcon,
        resetApp,
        testAppEmailExt,
        testAppSMSExt,
        createAppInvite,
        apiRequest,
        createAppSignup,
        getAppSignup,
        deleteAppSignup,
        deleteAppUser,
        updateAppUserStatus,
        getAppEmailTemplate,
        updateEmailTemplate,
        updateAppLocale,
        createUserSignup,
        verifiyUserSignup,
        signupComplete,
        login,
        loginAnonymous,
        loginAnonymousComplete,
        loginComplete,
        verifyUserComplete,
        verifyUser,
        getAppUser,
        getAppGroup,
        createAppGroup,
        updateAppGroup,
        deleteAppGroup,
        getActionEmailTemplate,
        updateActionEmailTemplate,
        createAppAction,
        updateAppAction,
        updateAppActionCeremony,
        deleteAppAction,
        updateActionQR,
        getActionQR,
        copyActionQR,
        createActionQR,
        deleteActionQR,
        getAppAction,
        updateAppUserGroup,
        appLogs,
        exportAppLog,
        addPasskeyComplete,
        addPasskey,
        resetAppUserPasskey,
        checkURL,
        exportAppDatabase,
        importAppDatabase,
        exportAppUser
    }

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    )

}